import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import AgendaPage from "./pages/AgendaPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import ProducerDashboard from "./pages/ProducerDashboard";
import ProducerSpace from "./pages/ProducerSpace";
import LoginPage from "./pages/LoginPage";
import DonatePage from "./pages/DonatePage";
import ConvictionPage from "./pages/ConvictionPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projets" element={<ProjectsPage />} />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/conviction" element={<ConvictionPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faire-un-don" element={<DonatePage />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/producteur/:token" element={<ProducerSpace />} />
          <Route path="/projet/:token" element={<ProducerDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
